/**
 * Returns the sanitized string if the input is a valid in-progress decimal
 * value (digits only, optional single decimal, max 2 fractional digits).
 * Returns `null` to reject the input (caller should ignore the change).
 *
 * Used for currency, hours, and quantity fields.
 *
 * Allowed in-progress inputs: "", "1", "12", "12.", "12.5", "12.50"
 * Rejected: "12.555", "12.5.5", "abc", "-1", "1,5"
 */
export const sanitizeDecimalInput = (raw: string): string | null => {
  if (raw === '') {
    return '';
  }
  if (!/^\d+(\.\d{0,2})?$/.test(raw)) {
    return null;
  }
  return raw;
};
